import api from '../api';

export const cloudPrepApi = api.injectEndpoints({
  endpoints: builder => ({
    startCloudPrepTest: builder.mutation({
      query: ({ testSetId, testType }) => ({
        url: '/api/cloud/prep/start/test',
        method: 'POST',
        params: { testSetId, testType }
      }),
      invalidatesTags: ['AssignedTests']
    }),
    resumeCloudPrepTest: builder.mutation({
      query: ({ userTestId, testSetId }) => ({
        url: '/api/cloud/prep/resume/test',
        method: 'GET',
        params: { userTestId, testSetId }
      }),
      invalidatesTags: ['AssignedTests']
    }),
    discardCloudPrepTest: builder.mutation({
      query: ({ userTestId, testSetId, testType }) => ({
        url: '/api/cloud/prep/discrad/test',
        method: 'POST',
        params: { userTestId, testSetId, testType }
      }),
      invalidatesTags: ['AssignedTests']
    }),
    endCloudPrepTest: builder.mutation({
      query: ({ userTestId, testType }) => ({
        url: '/api/cloud/prep/endtest',
        method: 'PUT',
        params: { userTestId, testType }
      })
    }),
    saveCloudPrepTest: builder.mutation({
      query: ({ userTestId, body }) => ({
        url: '/api/cloud/prep/saveusertest',
        method: 'PUT',
        params: { userTestId },
        body
      })
    }),
    getAssignedTests: builder.query({
      query: ({ company, testType, totalTestCount }) => ({
        url: '/api/cloud/prep/assigned/tests',
        method: 'GET',
        params: { company, testType, totalTestCount }
      }),
      providesTags: ['AssignedTests']
    }),
    fetchCloudPrepUserTests: builder.query({
      query: ({ page, userId, size }) => ({
        url: '/api/cloud/prep/fetchusertests',
        method: 'GET',
        params: { page, userId, size }
      }),
      providesTags: ['UserTests']
    }),
    fetchCloudPrepUserTest: builder.query({
      query: ({ userTestId, userId }) => ({
        url: '/api/cloud/prep/fetchusertest',
        method: 'GET',
        params: { userTestId, userId }
      })
    })
  })
});

export const {
  useStartCloudPrepTestMutation,
  useGetAssignedTestsQuery,
  useResumeCloudPrepTestMutation,
  useDiscardCloudPrepTestMutation,
  useEndCloudPrepTestMutation,
  useSaveCloudPrepTestMutation,
  useLazyFetchCloudPrepUserTestQuery,
  useFetchCloudPrepUserTestQuery,
  useFetchCloudPrepUserTestsQuery,
  useLazyFetchCloudPrepUserTestsQuery
} = cloudPrepApi;
